// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19iZ3","toggleWrap":"styles_toggleWrap__ZrFWa","content":"styles_content__20qbY","selectAreaCode":"styles_selectAreaCode__UaDGM"};